import { Card, Col, Row, Table } from "antd";
import { useEffect, useState } from "react";
import { REPEAT_OFFENDER_DASHBOARD } from "../../apis/apis";
import { LeftOutlined } from "@ant-design/icons";
import CulsightPageLoader from "../../components/CulsightPageLoader";
import { useLocation, useParams,useNavigate } from "react-router-dom";

function OffenderCampDetails() {
  const location = useLocation();
  const { user_id } = useParams();
  const navigate = useNavigate();

  const [loader, setLoader] = useState(true);
  const [users_data, set_users_data] = useState([]);
  const [table_data, set_table_data] = useState([]);

  // ---- LIST API ----
 const LIST_API = async () => {
  const FORM_DATA = new FormData(); 
  FORM_DATA.append('email', atob(user_id))
  try {
    const API_CALL = await REPEAT_OFFENDER_DASHBOARD(FORM_DATA);

    if (API_CALL?.data?.status) {
     console.log()
      const user = API_CALL?.data.data.find(item =>  item.email === atob(user_id));
      
      if (user) {
        set_users_data(user);
        set_table_data(user.campaign_details || []);
      } else {
        set_users_data({});
        set_table_data([]);
      }
    }
  } catch (err) {
    console.error("Error:", err);
  }

  setLoader(false);
};


  useEffect(() => {
    LIST_API();
  }, []);

  // ---- Table Columns ----
  const columns = [
    {
      title: "Campaign",
      dataIndex: "campaign_name",
      width: 200,
    },
    {
      title: "Clicked Browser",
      dataIndex: "clicked_browsers",
       width: 500,
    },
  {
  title: "Submitted Data",
  dataIndex: "submitted_data",
  render: (data) => {
    if (!data || Object.keys(data).length === 0) return "No Data";

    const formatted = Object.entries(data)
      .map(([key, value]) => {
        let v = value ? value : "null"; 
        return `${key} = ${v}`;
      })
      .join("\n");

    return (
      <pre
        style={{
          padding: "8px",
          borderRadius: "6px",
          maxWidth: "300px",
          whiteSpace: "pre-wrap",
        }}
      >
        {formatted}
      </pre>
    );
  },
}

  ];

  return (
    <div className="lms-body">
       <Row>
            <Col span={12}>
              <h2><span   style={{cursor: "pointer",marginRight:"5px"}}
              onClick={() => navigate("/offender")} ><LeftOutlined /></span>Campaign Details</h2>
            </Col>
          </Row>

      <Card>
        {loader ? (
          <CulsightPageLoader />
        ) : (
          <>
          <h3>Name: <i style={{color:"#8c3add"}}>{users_data?.name}</i>, Email: <i style={{color:"#8c3add"}}>{users_data?.email}</i></h3>
          <Table
            columns={columns}
            dataSource={table_data}
            pagination={false}
            rowKey="campaign_id"
            style={{ marginTop: "15px" }}
          />
          </>
        )}
      </Card>
    </div>
  );
}

export default OffenderCampDetails;
